import { render, staticRenderFns } from "./V2SearchDropdown.vue?vue&type=template&id=59af7003&scoped=true&"
import script from "./V2SearchDropdown.vue?vue&type=script&lang=js&"
export * from "./V2SearchDropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2SearchDropdown.vue?vue&type=style&index=0&id=59af7003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af7003",
  null
  
)

export default component.exports